/**
 * Seed derivation for drug avatars.
 *
 * Identity rule (FE-DRUG-AVATAR-1): the seed comes from the canonical asset
 * ID and nothing else. A name seed exists only as the explicit fallback for a
 * drug that has no resolvable asset. The two prefixes are distinct so a name
 * can never collide with an ID, and neither is ever derived from list
 * position, sponsor or display ordering.
 */

const ASSET_PREFIX = "asset:"
const NAME_PREFIX = "name:"

function normaliseName(name: string): string {
  return String(name).normalize("NFC").trim().toLowerCase().replace(/\s+/g, " ")
}

export function assetSeed(assetId: string): string {
  return `${ASSET_PREFIX}${assetId}`
}

export function nameSeed(name: string): string {
  return `${NAME_PREFIX}${normaliseName(name)}`
}

export const _internals = {
  ASSET_PREFIX,
  NAME_PREFIX,
  normaliseName,
}
